import {
  addDisplayName,
  addProps,
  addWrapper,
  CurriedUnchangedProps,
  flowMax,
} from 'ad-hok'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { FC, Ref } from 'react'

export const LAYOUT_MAX_WIDTH = 428
const useStyles = createUseStyles({
  constrainWidth: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: LAYOUT_MAX_WIDTH,
  },
  fillHeight: {
    height: '100%',
  },
  positionRelative: {
    position: 'relative',
  },
})

interface ConstrainWidthProps {
  fillHeight?: boolean
  positionRelative?: boolean
  className?: string
  innerRef?: Ref<HTMLDivElement>
  onScroll?: () => void
}

export const ConstrainWidth: FC<ConstrainWidthProps> = flowMax(
  addDisplayName('ConstrainWidth'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({
    fillHeight,
    positionRelative,
    innerRef,
    onScroll,
    className,
    children,
    classes,
  }) => (
    <div
      ref={innerRef}
      onScroll={onScroll}
      className={cx(
        classes.constrainWidth,
        fillHeight && classes.fillHeight,
        positionRelative && classes.positionRelative,
        className
      )}
    >
      {children}
    </div>
  )
)

type ConstrainWidthType = <TProps extends {}>(
  options?: ConstrainWidthProps
) => CurriedUnchangedProps<TProps>

export const constrainWidth: ConstrainWidthType = (options) =>
  flowMax(
    addWrapper((render) => (
      <ConstrainWidth {...options}>{render()}</ConstrainWidth>
    ))
  )
